import type { NorthStarDraft } from '../types';

function isNorthStarPlanComplete(draft: NorthStarDraft | null | undefined): boolean {
  return Boolean(draft?.plan?.items?.length);
}

function isNorthStarClarifyingQuestion(text: string): boolean {
  const t = text.trim();
  if (/\?\s*$/.test(t) && requestsNorthStarApproval(t)) {
    return false;
  }
  if (/\?\s*$/.test(t)) {
    return true;
  }
  return /\b(could you|would you|which of|what do you|please tell me|help me understand|before we proceed|need to know|need you to)\b/i.test(
    t,
  );
}

function requestsNorthStarApproval(text: string): boolean {
  return /\b(shall I|should I|does this look|look good|if this (looks|works)|let me know if|ready to (proceed|compute|validate)|want me to|would you like me to)\b/i.test(
    text,
  );
}

function suggestsNorthStarPendingAction(text: string): boolean {
  return /\b(I['']ll|I will|Let me|Let's|Going to|Next,? I|I am going to|I'm going to|We can now|Now I|I'll now|Let us)\b/i.test(
    text,
  );
}

/** Client-side fallback when the backend omits awaitingProceed. */
export function detectNorthStarAwaitingProceed(
  answer: string,
  draft: NorthStarDraft | null | undefined,
): boolean {
  if (isNorthStarPlanComplete(draft)) {
    return false;
  }
  if (isNorthStarClarifyingQuestion(answer)) {
    return false;
  }
  return (
    suggestsNorthStarPendingAction(answer) || requestsNorthStarApproval(answer)
  );
}
